import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

function NavTab({ tabs }: { tabs: string[] }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = searchParams.get('page') || tabs[0];

  useEffect(() => {
    if (!tabs.includes(activeTab)) {
      setSearchParams({ page: tabs[0] });
    }
  }, [activeTab, tabs, setSearchParams]);

  const handleTabClick = (page: string) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set('page', page);
      return newParams;
    });
  };

  return (
    <div>
      <ul className="flex p-1 gap-1 rounded items-center text-xs sm:text-sm font-semibold text-text justify-center bg-neutral-100 w-fit">
        {tabs.map((tab) => (
          <button
            type="button"
            key={tab}
            className={`px-3 py-1.5 rounded cursor-pointer transition-colors duration-300 ${
              activeTab === tab ? 'bg-white shadow-sm' : 'bg-neutral-100 text-secondNeutral'
            }`}
            onClick={() => handleTabClick(tab)}
          >
            <p className="w-full line-clamp-1">{tab}</p>
          </button>
        ))}
      </ul>
    </div>
  );
}

export default NavTab;
